import { useTranslations } from 'next-intl';
import styles from './world-cup-2026-slider.module.scss';
import { useWcPromotionActivityNavigation } from '@/domains/wc-promotion/hooks/use-wc-promotion-activity-navigation';
import { CdnImg } from '@/features/cdn-img';
import { useWcPromotionActivityAssetLocale } from '@/domains/wc-promotion/hooks/use-wc-promotion-support-lang';
import { KafkaNote } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';

interface WorldCup2026SliderProps {
	onClose: () => void;
}

export const WorldCup2026Slider = ({
	onClose,
}: WorldCup2026SliderProps) => {
	const t = useTranslations('General');
	const assetLocale = useWcPromotionActivityAssetLocale();
	const { navigateToWcPromotionActivity } = useWcPromotionActivityNavigation();

	const handleClickButton = () => {
		setKafkaNormal({
			note: KafkaNote.WcPromotion2026,
			type: 1,
			action: 4
		});
		navigateToWcPromotionActivity();
		onClose();
	};

	return (
		<div className={styles.container}>
			<CdnImg
				src={`/images/promotion-activity-modal/world-cup-2026/${assetLocale}.png`}
				width={288}
				height={360}
				alt="World Cup 2026"
				isGalaxyFolder={true}
			/>
			<button
				className={styles.button}
				onClick={handleClickButton}
			>
				{t('lbl_PlayNow01')}
			</button>
		</div>
	)
}